/** Core domain enums, shared by the API and the web client. */
export const FILE_STATUSES = ['AVAILABLE', 'ISSUED', 'MISSING', 'WEEDED'];
export const FILE_STATUS_LABELS = {
    AVAILABLE: { en: 'Available', hi: 'उपलब्ध' },
    ISSUED: { en: 'Issued', hi: 'निर्गत' },
    MISSING: { en: 'Missing', hi: 'अनुपलब्ध' },
    WEEDED: { en: 'Weeded out', hi: 'नष्टीकृत' },
};
/**
 * Which survey form a record came from.
 *
 * Form 1 and Form 2 share an identical location + identity block; Form 2 adds
 * the property fields (scheme, society, plot, allottee). They are therefore one
 * table with nullable property columns, and this field records which data-entry
 * view produced the row.
 */
export const FILE_KINDS = ['GENERAL', 'PROPERTY'];
export const FILE_KIND_LABELS = {
    GENERAL: { en: 'General file', hi: 'सामान्य फाइल' },
    PROPERTY: { en: 'Property / lease file', hi: 'सम्पत्ति / पट्टा फाइल' },
};
export const MOVEMENT_PURPOSES = [
    'VERIFICATION',
    'COURT_CASE',
    'MUTATION',
    'AUDIT',
    'RTI',
    'INSPECTION',
    'OTHER',
];
export const MOVEMENT_PURPOSE_LABELS = {
    VERIFICATION: { en: 'Verification', hi: 'सत्यापन' },
    COURT_CASE: { en: 'Court case', hi: 'न्यायालय प्रकरण' },
    MUTATION: { en: 'Mutation / name change', hi: 'नामांतरण' },
    AUDIT: { en: 'Audit', hi: 'अंकेक्षण' },
    RTI: { en: 'RTI request', hi: 'सूचना का अधिकार' },
    INSPECTION: { en: 'Inspection', hi: 'निरीक्षण' },
    OTHER: { en: 'Other', hi: 'अन्य' },
};
export function formatLocation(loc) {
    if (!loc)
        return '—';
    return `Room ${loc.roomCode} · Rack ${loc.rackCode} · Column ${loc.columnCode} · Bag ${loc.bagCode}`;
}
